import { Route } from '@angular/router';
import { PlanningEditComponent } from 'src/app/pages/campaigns/plannings/planning-edit/planning-edit.component';
import { PlanningComponent } from 'src/app/pages/campaigns/plannings/planning/planning.component';
import { PlanningsListComponent } from 'src/app/pages/campaigns/plannings/plannings-list/plannings-list.component';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { SbPartialPlanningComponent } from '../../../../../components/booking-editor/partial-planning/sb-partial-planning.component';

export const plannings: Route = {
  path: 'plannings',
  title: 'nav.campaigns.plannings',
  data: {
    icon: SbIcons.plannings,
    breadcrumb: 'nav.campaigns.plannings',
    id: RoutingID.plannings,
  },
  children: [
    {
      path: '',
      component: PlanningsListComponent,
      data: {
        breadcrumb: '',
      },
    },
    {
      path: 'planning/:planningID',
      data: {
        breadcrumb: 'nav.campaigns.plannings',
        id: RoutingID.planning,
      },
      children: [
        {
          path: '',
          component: PlanningComponent,
          title: 'nav.campaigns.plannings',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'planning-view',
      data: {
        breadcrumb: 'nav.campaigns.plannings',
        id: RoutingID.planningView,
      },
      children: [
        {
          path: '',
          component: PlanningComponent,
          title: 'nav.campaigns.plannings',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'planning-edit/:planningID',
      data: {
        breadcrumb: 'nav.campaigns.plannings.edit',
        id: RoutingID.planningEdit,
      },
      children: [
        {
          path: '',
          component: PlanningEditComponent,
          title: 'nav.campaigns.plannings.edit',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'planning-create',
      data: {
        breadcrumb: 'nav.campaigns.plannings.create',
        id: RoutingID.planningCreate,
      },
      children: [
        {
          path: '',
          component: PlanningEditComponent,
          title: 'nav.campaigns.plannings.create',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
    {
      path: 'planning/:planningID/partialPlanning',
      data: {
        icon: SbIcons.planningSubmit,
        breadcrumb: 'nav.campaigns.partialPlannings',
        id: RoutingID.partialPlanning,
      },
      children: [
        {
          path: '',
          component: SbPartialPlanningComponent,
          title: 'nav.campaigns.partialPlannings',
          data: {
            breadcrumb: '',
          },
        },
      ],
    },
  ],
};
